import api from './client';

export type CategorySection = 'legal' | 'maintenance';

export interface ServiceCategory {
  id: number;
  name: string;
  section: CategorySection;
  icon: string | null;
  description: string | null;
  image: string | null;
  displayOrder: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ServiceCategoryInput {
  name: string;
  section?: CategorySection;
  icon?: string | null;
  description?: string | null;
  image?: string | null;
  displayOrder?: number;
  isActive?: boolean;
}

interface ListResponse {
  status: number;
  total: number;
  categories: ServiceCategory[];
}

interface MutationResponse {
  status: number;
  message?: string;
  error?: string | string[];
  category?: ServiceCategory;
}

/** GET /api/service-categories */
export const listServiceCategories = async (
  section?: CategorySection,
  active?: boolean
): Promise<ServiceCategory[]> => {
  const params: Record<string, string> = {};
  if (section) params.section = section;
  if (active === true) params.active = 'true';
  if (active === false) params.active = 'false';
  const res = await api.get<ListResponse>('/service-categories', { params });
  return res.data.categories;
};

/** POST /api/service-categories (admin) */
export const createServiceCategory = async (
  payload: ServiceCategoryInput
): Promise<ServiceCategory> => {
  const res = await api.post<MutationResponse>('/service-categories', payload);
  if (!res.data.category) throw new Error('No category returned');
  return res.data.category;
};

/** PUT /api/service-categories/:id (admin) */
export const updateServiceCategory = async (
  id: number,
  payload: ServiceCategoryInput
): Promise<ServiceCategory> => {
  const res = await api.put<MutationResponse>(`/service-categories/${id}`, payload);
  if (!res.data.category) throw new Error('No category returned');
  return res.data.category;
};

/** PATCH /api/service-categories/:id/toggle (admin) */
export const toggleServiceCategory = async (
  id: number
): Promise<ServiceCategory> => {
  const res = await api.patch<MutationResponse>(`/service-categories/${id}/toggle`);
  if (!res.data.category) throw new Error('No category returned');
  return res.data.category;
};

/** DELETE /api/service-categories/:id (admin) */
export const deleteServiceCategory = async (id: number): Promise<void> => {
  await api.delete<MutationResponse>(`/service-categories/${id}`);
};
